import { app } from '../../../app';
import {
    toDirectoryDTO
} from './directory-integration.functions';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration', {
        url: '/directory-integration',
        redirectTo: 'company.directory-integration.list',
        component: 'companyDirectoryIntegration',
        resolve: {directories},
    });
}

/** @ngInject */
function directories(companyId, DirectoriesResource) {
    return DirectoriesResource.getCompanyDirectories(companyId)
    	.then(directories => directories.map(directory => (toDirectoryDTO(directory))));
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/directory-integration.state.js